import React, { Component } from "react";
import AccountingExportsFields from "./AccountingExportsFields";

class AccountingExportsPage extends Component {
  constructor(props, context) {
    super(props, context);
  }


  render() {

    return (
      <div className="sub-container">
        <div className="sub-content">
          <div className="standalone-form import-export">
            <AccountingExportsFields/>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountingExportsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/accounting/AccountingExportsPage.js